module.exports = __webpack_public_path__ + "img/scotland.7d2a91f5.svg";